var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"base-btn",attrs:{"tag":_vm.tagName,"to":_vm.target},nativeOn:{"click":function($event){return _vm.handleCheckoutClick($event)}}},[_vm._v(_vm._s(_vm.caption))])}
var staticRenderFns = []

export { render, staticRenderFns }